enum MedicationCoverage {
    NotCovered = 0,
    Covered = 1,
    LimitedCoverage = 2,
    PartialCoverage = 3
}

export { MedicationCoverage };
